<template>
    <div class="sidebar">
        <div class="sidebar-listing">
            <span class="close-side-bar" @click="$emit('closeSidemenu')">
                <i class="icon-delete"></i>
            </span>

            <!-------------------------------adding new code here-------------------------------------->

            <!-------------------------------adding new code here-------------------------------------->
            <div class="sidebar-nav">
                <div class="logo-container">
                    <base-logo></base-logo>
                </div>
                <div class="navigation">
                    <ul>
                        <li
                            v-for="(list, index) in sidebarNavItems"
                            v-if="list.show"
                            :key="list.key || index"
                            @click="handleItemClick(index)"
                        >
                            <a
                                v-if="list.action === 'helpdesk'"
                                href="#"
                                class="sidebar-help-menu-link"
                                :class="{ 'is-disabled': isLoadingHelp }"
                                @click.prevent="openHelpdesk()"
                            >
                                <i :class="list.icon"></i>
                                <span>{{ list.menuLabel }}</span>
                            </a>
                            <router-link
                                v-else-if="!list.dropdown"
                                :to="list.anchorLink"
                            >
                                <i :class="list.icon"></i>
                                <span>{{ list.menuLabel }}</span>
                            </router-link>
                            <div v-else>
                                <div
                                    class="dropdown"
                                    @click="toggleDropdown(index)"
                                >
                                    <i :class="list.icon"></i>
                                    <span>{{ list.menuLabel }}</span>
                                    <i
                                        :class="
                                            list.dropdownOpen
                                                ? 'arrow-up'
                                                : 'arrow-down'
                                        "
                                    ></i>
                                </div>
                                <ul v-show="list.dropdownOpen">
                                    <li
                                        v-for="(
                                            dropdownItem, dropdownIndex
                                        ) in list.dropdownOptions"
                                        :key="dropdownIndex"
                                        @click="$emit('onClick')"
                                    >
                                        <router-link
                                            :to="dropdownItem.anchorLink"
                                        >
                                            <span>{{
                                                dropdownItem.menuLabel
                                            }}</span>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>

                <login-popover></login-popover>
            </div>
        </div>

        <div v-if="user.userGuide" class="user-guide">
            <b-button variant="primary" @click="openModal()">
                <i class="icon-eforms mr-1" style="font-size: 12px"></i>
                <span class="">User Guide</span>
            </b-button>
        </div>

        <login-detail> </login-detail>
        <user-guide-popup> </user-guide-popup>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import loginDetail from '@/components/LoginDetail.vue'
import loginPopover from '@/components/LoginPopover.vue'
import UserGuidePopup from '@/components/popups/UserGuidePopup.vue'
import resource from '@/api/resource'
import _ from 'lodash'
const dataSegmentApi = new resource('access-control/data-segments')
const viewBrandingApi = new resource('configurations/branding')
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: { loginDetail, loginPopover, UserGuidePopup },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            dataSegmentListing: [],
            userDataSegmentIds: [],
            // Data Segment listing variables
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                roleId: null,
                dataSegmentId: null,
            },
            country: process.env.VUE_APP_COUNTRY,
            image: 'profile-pic.png',
            sidelinksListing: [
                {
                    anchorLink: '/insights',
                    icon: 'icon-insights',
                    menuLabel: 'Insights',
                    permission: [
                        'view-alerts',
                        'view-activity-dashboard',
                        'view-customer-statistics',
                    ],
                    dropdown: false,
                    show: true,
                },
                {
                    anchorLink: '/customer-profiles',
                    icon: 'icon-customer-profil',
                    menuLabel: 'Profiles',
                    permission: [
                        'view-customer-profile',
                        'view-deeplink-sent',
                        'bulk-upload',
                    ],
                    dropdown: false,
                    show: true,
                },
                {
                    anchorLink: '/register-customer',
                    icon: 'icon-add-customer',
                    menuLabel: 'Deep Link Onboarding',
                    permission: ['register-customer'],
                    dropdown: false,
                    show: false,
                    key: 'kyc-deep-link',
                },
                {
                    anchorLink: '#',
                    icon: 'icon-add-customer',
                    menuLabel: 'Deep Link Onboarding',
                    dropdown: true,
                    dropdownOpen: false,
                    show: true,
                    key: 'kyb-deep-link',
                    permission: ['register-customer'],
                    dropdownOptions: [
                        {
                            anchorLink: '/register-customer',
                            icon: 'icon-add-customer',
                            menuLabel: 'Individual Onboarding',
                            permission: ['register-customer'],
                        },
                        {
                            anchorLink: '/register-company',
                            icon: 'icon-add-customer',
                            menuLabel: 'Company Onboarding',
                            permission: ['register-company'],
                        },
                    ],
                },

                {
                    anchorLink: '#',
                    icon: 'icon-add-customer',
                    menuLabel: 'Self Service Onboarding',
                    dropdown: true,
                    dropdownOpen: false,
                    show: true,
                    key: 'kyb-register',
                    permission: ['register-customer'],
                    dropdownOptions: [
                        {
                            anchorLink: '/self-register/upload-document',
                            icon: 'icon-add-customer',
                            menuLabel: 'Individual Onboarding',
                            permission: ['register-customer'],
                        },
                        {
                            anchorLink:
                                '/self-register-company/upload-document',
                            icon: 'icon-add-customer',
                            menuLabel: 'Company Onboarding',
                            permission: ['register-company'],
                        },
                    ],
                },
                {
                    anchorLink: '/self-register/upload-document',
                    icon: 'icon-add-customer',
                    menuLabel: 'Self Service Onboarding',
                    permission: ['register-customer'],
                    dropdown: false,
                    show: false,
                    key: 'kyc-register',
                },
                {
                    anchorLink: '/bulk-customers-onboarding',
                    icon: 'icon-documentation1',
                    menuLabel: 'Bulk Onboarding',
                    permission: ['bulk-upload'],
                    dropdown: false,
                    show: true,
                },

                {
                    anchorLink: '/configuration/on-boarding-configuration/',
                    icon: 'icon-configurations',
                    menuLabel: 'Configurations',
                    permission: ['configurations'],
                    dropdown: false,
                    show: true,
                },
                {
                    anchorLink: '/screening-data/delta-list',
                    icon: 'icon-configurations',
                    menuLabel: 'Upload Delta',
                    permission: ['upload-delta-list'],
                    dropdown: false,
                    show: true,
                },
                {
                    anchorLink: '/billing',
                    icon: 'icon-account_balance',
                    menuLabel: 'Packages',
                    permission: ['subscribe-package'],
                    key: 'packages',
                    dropdown: false,
                    show: true,
                },
                {
                    anchorLink: '/team-members',
                    icon: 'icon-system-users',
                    menuLabel: 'Team Members',
                    permission: ['view-team-members', 'manage-team-members'],
                    dropdown: false,
                    show: true,
                },
                {
                    anchorLink: '/users',
                    icon: 'icon-system-users',
                    menuLabel: 'Users',
                    permission: [
                        'view-users',
                        'manage-users',
                        'view-roles',
                        'manage-roles',
                        'view-data-segments',
                        'manage-data-segments',
                        // 'view-application-access',
                        // 'manage-application-access',
                    ],
                    dropdown: false,
                    show: true,
                },
                {
                    anchorLink: '/customer-verification',
                    icon: 'icon-system-users',
                    menuLabel: 'Customer Verification',
                    permission: [
                        'view-customer-verification',
                        'manage-customer-verification',
                    ],
                    dropdown: false,
                    show: true,
                },
                {
                    anchorLink: '/notifications',
                    icon: 'icon-system-users',
                    menuLabel: 'Notifications',
                    permission: [
                        'view-notifications',
                        'manage-notifications',
                    ],
                    dropdown: false,
                    show: true,
                },
                {
                    anchorLink: '/system-logs',
                    icon: 'icon-system-log',
                    menuLabel: 'System Logs',
                    permission: ['system-logs'],
                    key: 'systemLogs',
                    dropdown: false,
                    show: true,
                },
                {
                    anchorLink: '/developers',
                    icon: 'icon-review',
                    menuLabel: 'Developer Tools',
                    permission: ['developer-tools'],
                    dropdown: false,
                    show: true,
                },
            ],
            dataSegmentId: null,
            activeDataSegId: 1,
            isLoadingHelp: false,
        }
    }, // End of Component > data
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'user',
            'scopes',
            'hasScopes',
            'refreshDataSegmentList',
        ]),
        allowedSidelinksListing() {
            if (!this.user) {
                return []
            }
            let arr = this.sidelinksListing.filter((item) => {
                return this.checkPermission(item.permission)
            })

            for (var key in arr) {
                if (this.user.kyb) {
                    if (
                        arr[key].key == 'kyb-deep-link' ||
                        arr[key].key == 'kyb-register'
                    ) {
                        arr[key].show = true
                    }
                    if (
                        arr[key].key == 'kyc-deep-link' ||
                        arr[key].key == 'kyc-register'
                    ) {
                        arr[key].show = false
                    }
                } else {
                    if (
                        arr[key].key == 'kyb-deep-link' ||
                        arr[key].key == 'kyb-register'
                    ) {
                        arr[key].show = false
                    }
                    if (
                        arr[key].key == 'kyc-deep-link' ||
                        arr[key].key == 'kyc-register'
                    ) {
                        arr[key].show = true
                    }
                }

                if (this.user.accountType == 'lite') {
                    if (
                        arr[key].key == 'systemLogs' ||
                        arr[key].key == 'kyb-deep-link' ||
                        arr[key].key == 'kyc-deep-link'
                    ) {
                        arr[key].show = false
                    }
                }

                if (arr[key].menuLabel == 'Profiles') {
                    if (!this.hasScopes('view-customer-profile')) {
                        arr[key].anchorLink =
                            '/customer-profiles/temp-customers'
                    }
                }
            }

            return arr
        },
        sidebarNavItems() {
            const items = this.allowedSidelinksListing.slice()
            if (this.user) {
                items.push({
                    key: 'helpdesk',
                    icon: 'icon-error',
                    menuLabel: this.isLoadingHelp
                        ? 'Loading...'
                        : 'Help Desk',
                    action: 'helpdesk',
                    show: true,
                    dropdown: false,
                })
            }
            return items
        },
        activeDataSegmentList() {
            return this.dataSegmentListing.filter((item) => {
                return (item.status = 'active')
            })
        },
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.$store.commit('setDataSegmentId', value)
            }
        },
        user(value) {
            if (!value && this.$route.meta.requiresAuth) {
                this.$router.push({ name: 'login-page' })
            }
        }, // End of user() method
        refreshDataSegmentList(value) {
            if (value) {
                this.getRecords()
                this.$store.commit('setRefreshDataSegmentList', false)
            }
        }, // End of refreshDataSegmentList() method
    }, // End of Component > watch
    async created() {
        // Load All Data Segments
        if (!localStorage.getItem('displaySettings')) {
            await this.getBrandingData()
        }
        // await this.getRecords()
    }, // End of Component > created
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        openModal() {
            this.$bvModal.show('user-guide')
        },
        async openHelpdesk() {
            if (this.isLoadingHelp) return
            this.isLoadingHelp = true
            await this.$store.dispatch('helpdeskSsoRedirect')
            this.isLoadingHelp = false
        },
        handleItemClick(index) {
            if (
                this.user &&
                index === this.allowedSidelinksListing.length
            ) {
                this.allowedSidelinksListing.forEach((item) => {
                    if (item.dropdownOpen !== undefined) {
                        item.dropdownOpen = false
                    }
                })
                return
            }
            for (let i = 0; i < this.allowedSidelinksListing.length; i++) {
                if (i !== index) {
                    this.allowedSidelinksListing[i].dropdownOpen = false
                }
            }
        },
        toggleDropdown(index) {
            this.allowedSidelinksListing[index].dropdownOpen =
                !this.allowedSidelinksListing[index].dropdownOpen
        },
        async getRecords() {
            let self = this
            // Data segments option list
            let { data } = await dataSegmentApi.list(self.query)
            let dataSegmentId = null
            let localStorageTem = localStorage.getItem('dataSegmentId')
            if (self.user && data.data) {
                if (
                    self.user.dataSegmentIds &&
                    self.user.dataSegmentIds.length
                ) {
                    self.userDataSegmentIds = self.user.dataSegmentIds
                    data.data.forEach(function (ele) {
                        if (self.userDataSegmentIds.includes(ele._id)) {
                            self.dataSegmentListing.push(ele)
                        }
                    })
                    dataSegmentId = self.dataSegmentListing[0]
                        ? self.dataSegmentListing[0]._id
                        : null
                } else {
                    self.dataSegmentListing = data.data
                    if (self.dataSegmentListing.length) {
                        dataSegmentId = self.dataSegmentListing[0]
                            ? self.dataSegmentListing[0]._id
                            : null
                    }
                }
                if (localStorageTem) {
                    let check = this.dataSegmentListing.find(
                        (x) => x._id === localStorageTem
                    )
                    if (check) {
                        this.dataSegmentId = localStorageTem
                    } else {
                        this.dataSegmentId = dataSegmentId
                    }
                } else {
                    localStorage.setItem('dataSegmentId', dataSegmentId)
                    this.dataSegmentId = dataSegmentId
                }
            }
            // Get all data segments in dataSegmentListing
        }, // End of getOptionsList() method
        setDataSegmetId(val, id) {
            this.activeDataSegId = val
            this.dataSegmentId = id
            localStorage.setItem('dataSegmentId', id)
        },
        checkPermission(scopes) {
            return !!_.intersection(scopes, this.scopes).length
        },
        async getBrandingData() {
            let { data } = await viewBrandingApi.list()
            this.$store.commit('setDisplaySetting', data.data)
        }, // End of getBrandingData() method
    }, // End of Component > methods
} // End of export default
</script>
<style>
.sidebar .sidebar-nav .navigation ul li div div span {
    font-family: 'ProximanovaLight';
    font-size: 0.875rem;
    top: 3px;
    color: #e4e4e6;
    vertical-align: super;
    position: relative;
}
.navigation ul li div div i {
    font-size: 21px;
    margin-right: 12px;
    position: relative;
    top: 2px;
    color: #e4e4e6;
}
.sidebar .sidebar-nav .navigation ul li div {
    color: #e4e4e6;
    padding: 8px 2px;
    vertical-align: middle;
    cursor: pointer;
}
.arrow-up:before {
    content: '\25B2'; /* Unicode for upward arrow */
}

.arrow-down:before {
    content: '\25BC'; /* Unicode for downward arrow */
}

.dropdown {
    overflow: hidden;
    transition: max-height 0.3s ease-in-out; /* Adjust the transition duration as needed */
}
.arrow-down,
.arrow-up {
    font-size: 12px !important;
    top: -2px !important;
    margin-left: 10px !important;
}
.sidebar-help-menu-link.is-disabled {
    opacity: 0.6;
    pointer-events: none;
}
.user-guide {
    position: absolute;
    bottom: 10px;
    /*right: 10px;*/
    left: 45px;
}
</style>
